var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClip({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 15,
    viewBox: "0 0 9 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.03459 14.9999C2.97288 15.0055 1.95087 14.5964 1.18622 13.8597C0.428464 13.1384 -0.000292817 12.138 1.50038e-07 11.0918V6.23335C1.50038e-07 6.02622 0.16787 5.85835 0.374998 5.85835C0.582125 5.85835 0.749995 6.02622 0.749995 6.23335V11.0918C0.750581 11.9342 1.09643 12.7397 1.70712 13.3199C2.33216 13.9214 3.16727 14.2551 4.03459 14.2499C5.84586 14.2499 7.31919 12.8332 7.31919 11.0918V2.85148C7.31861 2.29133 7.08863 1.75593 6.68258 1.36995C6.26524 0.969024 5.70802 0.746516 5.12926 0.750031C3.9218 0.750031 2.93934 1.6928 2.93934 2.85148V9.72302C2.93934 10.2986 3.4305 10.7666 4.03386 10.7666C4.63899 10.7666 5.13 10.2986 5.13 9.72302V6.23335C5.13 6.02622 5.29787 5.85835 5.50499 5.85835C5.71212 5.85835 5.87999 6.02622 5.87999 6.23335V9.72302C5.87999 10.7121 5.05251 11.5166 4.03533 11.5166C3.01683 11.5166 2.18934 10.7121 2.18934 9.72302V2.85148C2.18934 1.27928 3.50813 3.60676e-05 5.12926 3.60676e-05C5.9024 -0.00377248 6.64669 0.294175 7.20362 0.830451C7.75659 1.35735 8.06948 2.08787 8.06919 2.85178V11.0918C8.06919 13.2467 6.25939 14.9999 4.03459 14.9999Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClip);
export default __webpack_public_path__ + "static/media/clip.da1854cff97ff665c7d8d0d258f19dcd.svg";
export { ForwardRef as ReactComponent };